module.exports = __webpack_public_path__ + "img/LitheumLogo.083ebb95.png";